package game.entity

import game.Game
import game.Room

class Lore: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = if (game.isLoreDiscovered()) {
            game.getSpriteById("lore")
        } else {
            game.getSpriteById("lore-active")
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.addLoreFromCurrentRoom()
        sprite = game.getSpriteById("lore")

        return false
    }
}